var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTechnology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78,
    height: 78.089,
    viewBox: "0 0 78 78.089",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1503",
    "data-name": "Rectangle 1503",
    width: 78,
    height: 78.089,
    fill: "#ef4c1c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566",
    transform: "translate(0 -0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9334",
    "data-name": "Path 9334",
    d: "M37.91,0a6.625,6.625,0,0,0-1.53,13.071V26.137a1.53,1.53,0,0,0,3.06,0V13.071A6.625,6.625,0,0,0,37.91,0m0,9.985a3.361,3.361,0,1,1,3.359-3.361A3.365,3.365,0,0,1,37.91,9.985",
    transform: "translate(1.188 0.001)",
    fill: "#ef4c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9335",
    "data-name": "Path 9335",
    d: "M21.5,54.53a1.536,1.536,0,0,0-2.164,0L10.1,63.771a6.623,6.623,0,1,0,2.164,2.164L21.5,56.693a1.529,1.529,0,0,0,0-2.163M9,71.786a3.361,3.361,0,1,1,0-4.752,3.341,3.341,0,0,1,0,4.752",
    transform: "translate(0 2.054)",
    fill: "#ef4c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9336",
    "data-name": "Path 9336",
    d: "M74.008,64.5a6.62,6.62,0,0,0-8.157-.956l-9.242-9.24a1.53,1.53,0,0,0-2.164,2.162l9.242,9.242A6.623,6.623,0,1,0,74.008,64.5M71.7,71.563a3.361,3.361,0,1,1,0-4.752,3.333,3.333,0,0,1,0,4.752",
    transform: "translate(2.05 2.045)",
    fill: "#ef4c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9337",
    "data-name": "Path 9337",
    d: "M70.853,25.337a1.182,1.182,0,0,1,.017.21V56.352a1.53,1.53,0,0,1-3.06,0V27.358L40.384,38.033v35.4l15.846-6.159a1.53,1.53,0,0,1,1.11,2.851l-17.93,6.967a1.079,1.079,0,0,1-.138.047,1.12,1.12,0,0,1-.116.029.211.211,0,0,1-.046.007l-.038.006a.253.253,0,0,1-.057.006.371.371,0,0,1-.067.006.688.688,0,0,1-.093,0c-.037,0-.074,0-.11,0l-.053-.006c-.027,0-.054-.006-.082-.01a.545.545,0,0,1-.074-.014,1.8,1.8,0,0,1-.23-.067l-.022-.008L19.63,69.911a1.53,1.53,0,1,1,1.1-2.855l16.6,6.385V38.067L9.47,28.226V56.352a1.529,1.529,0,1,1-3.059,0V26.4a1.368,1.368,0,0,1,.008-.161c0-.046-.008-.092-.008-.139a1.53,1.53,0,0,1,.955-1.452L29.5,15.669A1.53,1.53,0,0,1,30.65,18.5L12.255,25.967l26.573,9.388L65.077,25.138l-17.454-6.62a1.53,1.53,0,0,1,1.085-2.862l21.176,8.034a1.529,1.529,0,0,1,.987,1.424,1.317,1.317,0,0,1-.017.222",
    transform: "translate(0.243 0.591)",
    fill: "#ef4c1c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnology);
export default __webpack_public_path__ + "static/media/technology.d93c14595f7c370ee49cb8f90969c307.svg";
export { ForwardRef as ReactComponent };